export const validationMessages = {
  editLabel: "Label is required for edit process.",
  editTitle: "Title is required for edit process.",
  addLabel: "Label is required.",
  addTitle: "Title is required.",
  labelExist:
    "Label is already exist! Please use different label or use existing label from activities table.",
};
